import { CaretLeft, CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { useCallback } from 'react';
import Header from '@/components/Lightbox/Header/Header';
import Lightbox, { ImagesListType } from 'react-spring-lightbox';

type Props = {
    deactivateLightbox: () => void;
    enableLightboxBundle: boolean;
    galleryTitle: string;
    gotoNext: () => void;
    gotoPrevious: () => void;
    imageGalleryIndex: number;
    itemId: number;
    lightboxImages: ImagesListType;
    showLightBox: boolean;
};

export const ImageSliderGalleryLightbox = ({
    deactivateLightbox,
    enableLightboxBundle,
    galleryTitle,
    gotoNext,
    gotoPrevious,
    imageGalleryIndex,
    itemId,
    lightboxImages,
    showLightBox,
}: Props) => {
    const renderHeader = useCallback(() => {
        return (
            <Header
                currentImageIndex={imageGalleryIndex}
                galleryLength={lightboxImages.length}
                galleryTitle={galleryTitle}
                itemId={itemId}
                onClose={deactivateLightbox}
            />
        );
    }, [imageGalleryIndex, lightboxImages.length, galleryTitle, itemId, deactivateLightbox]);

    const renderNextButton = useCallback(
        () => (
            <IconButton
                className="absolute right-sm z-10 xsMax:hidden"
                icon={CaretRight}
                iconStyle="bold"
                onClick={gotoNext}
                variant="outlined"
            />
        ),
        [gotoNext]
    );

    const renderPrevButton = useCallback(
        () => (
            <IconButton
                className="absolute left-sm z-10 xsMax:hidden"
                icon={CaretLeft}
                iconStyle="bold"
                onClick={gotoPrevious}
                variant="outlined"
            />
        ),
        [gotoPrevious]
    );

    if (Boolean(lightboxImages.length) && enableLightboxBundle) {
        return (
            <Lightbox
                className="bg-background-primary [&>img]:cursor-zoom-in"
                currentIndex={imageGalleryIndex}
                images={lightboxImages}
                isOpen={showLightBox}
                onClose={deactivateLightbox}
                onNext={gotoNext}
                onPrev={gotoPrevious}
                renderHeader={renderHeader}
                renderNextButton={renderNextButton}
                renderPrevButton={renderPrevButton}
                singleClickToZoom
            />
        );
    }
    return null;
};
